<style type="text/css">
  .card-body {
    padding: 0.5rem;
  }
</style>
<template>
  <form class="mt-2" id="form-modal" :data-show="getNotes">
    <!-- description input -->
    <div class="card text-center" v-for="note in notes">
      <div class="card-body">
        <p class="card-text">{{ note.description }}</p>
        <span style="float: right">{{ note.date }}</span>
      </div>
    </div>
    <h5 class="q-mt-none q-mb-sm q-pb-sm" v-if="notes.length < 1">
      No Notes Found.
    </h5>
  </form>
</template>

<script>
  // import Multiselect from 'vue-multiselect';
  import axios from "axios";

  export default {
    props: ["formData"],

    data: function () {
      return {
        notes: [],
      };
    },

    computed: {
      getNotes: function () {
          const permission = {
      headers: {
        'X-Permission': 'all_organization_view' 
      }
    };
        axios
          .get("/admin/users/get-user-all-notes?user_id=" + this.formData,permission)
          .then((response) => {
            this.notes = response.data;
          });
        return this.formData;
      },
    },
  };
</script>